"use strict";

/* global __quickSearchTemplates, __searchPageTemplates, __pageTemplates */

const Templates = {
	page: "",
	relatedQueries: "",
	suggestions: "",
	selectedFacets: "",
	checkboxBarFilter: "",
	filter: "",
	productTemplate: "",
	resultItemTemplate: "",
	checkboxTemplate: "",
	noProducts: '<p class="no-results-text">Ei tuotteita.</p>',
	noSearchResults: '<p class="no-results-text">Ei hakutuloksia.</p>'
};

/*
if (typeof __quickSearchTemplates === "object") {
	for (const key of Object.keys(__quickSearchTemplates)) {
		Templates[key] = __quickSearchTemplates[key];
	}
}

if (typeof __searchPageTemplates === "object") {
	for (const key of Object.keys(__searchPageTemplates)) {
		Templates[key] = __searchPageTemplates[key];
	}
}

if (typeof __pageTemplates === "object") {
	for (const key of Object.keys(__pageTemplates)) {
		Templates[key] = __pageTemplates[key];
	}
} */

for (const template of document.querySelectorAll(".category-template[data-category-template]")) {
	if (template.dataset.categoryTemplate) {
		Templates[template.dataset.categoryTemplate] = template.textContent;
	}
}

for (const template of document.querySelectorAll(".search-template[data-search-template]")) {
	if (template.dataset.searchTemplate) {
		Templates[template.dataset.searchTemplate] = template.textContent;
	}
}

if (Templates.searchPage && !Templates.page) {
	Templates.page = Templates.searchPage;
}

/*
Templates.suggestions = Templates.suggestions.replaceAll('<span class="is-icon is-icon-search"></span>', `<span class="search-icon"><?xml version="1.0" encoding="UTF-8"?>
<svg fill="none" width="14" height="14" version="1.1" viewBox="0 0 15.707 15.707" xmlns="http://www.w3.org/2000/svg">
	<circle cx="7" cy="7" r="6" stroke="#164196" stroke-width="2"/>
	<path d="m11 11 4 4" stroke="#164196" stroke-width="2"/>
</svg></span>`); */

export default Templates;
